module.exports = false;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_library.js
// module id = ../node_modules/core-js/modules/_library.js
// module chunks = 1